<template>
  <a-range-picker
    :value="value"
    format="DD/MM/YYYY"
    :locale="ptBR"
    :ranges="ranges"
    :allowClear="allowClear"
    :placeholder="['Início', 'Fim']"
    @change="change"
  />
</template>

<script>
import ptBR from "ant-design-vue/lib/date-picker/locale/pt_BR";
import moment from "moment";
import "moment/locale/pt-br";
import { currentMonth } from "./report-period";

/**
 * Período dos relatórios: o mesmo range picker da aba WhatsApp (pt-BR,
 * DD/MM/YYYY, atalhos), com v-model num par de moments.
 */
export default {
  name: "ReportPeriodPicker",
  props: {
    value: { type: Array, required: true },
    allowClear: { type: Boolean, default: false },
  },
  data() {
    return {
      ptBR,
      ranges: {
        "Este Mês": currentMonth(),
        "Mês Passado": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
        "Últimos 7 dias": [moment().subtract(7, "days"), moment()],
        "Últimos 30 dias": [moment().subtract(30, "days"), moment()],
        "Últimos 90 dias": [moment().subtract(90, "days"), moment()],
        "Este Ano": [moment().startOf("year"), moment()],
      },
    };
  },
  methods: {
    change(dates) {
      this.$emit("input", dates);
      this.$emit("change", dates);
    },
  },
};
</script>
